import { useController, useFormContext } from 'react-hook-form'

import type { MessageFallbackSelectorProps } from '@/modules/message/components/editor/fields/message-fallback-selector'
import { MessageFallbackSelector } from '@/modules/message/components/editor/fields/message-fallback-selector'

interface FormFields {
  fallback: string
  fallbackVariable: string
  enableFallbackVariable: boolean
}

type Props = Omit<
  MessageFallbackSelectorProps,
  'fallback' | 'fallbackVariable' | 'enableFallbackVariable'
>

export const MessageFallbackSelectorController = (props: Props) => {
  const { control } = useFormContext<FormFields>()
  const fallback = useController({ control, name: 'fallback' })
  const fallbackVariable = useController({ control, name: 'fallbackVariable' })
  const enableFallbackVariable = useController({
    control,
    name: 'enableFallbackVariable',
  })

  return (
    <MessageFallbackSelector
      {...props}
      fallback={{
        ...fallback.field,
        error: fallback.fieldState.error,
      }}
      fallbackVariable={{
        ...fallbackVariable.field,
        error: fallbackVariable.fieldState.error,
      }}
      enableFallbackVariable={{
        ...enableFallbackVariable.field,
        error: enableFallbackVariable.fieldState.error,
      }}
    />
  )
}
